import { Component, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    console.error("[ErrorBoundary]", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 32, fontFamily: "system-ui" }}>
          <h1>Something went wrong.</h1>
          <p style={{ color: "#64748B" }}>
            Refresh the page. If the problem persists, contact the workspace owner.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}
